/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
import NewPost from '@linc-technologies/linced-common/components/new-post';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import GroupType from '@linc-technologies/linced-common/enums/group-type';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';
import moment from 'moment';

export default class _NewPost extends NewPost {
  // Services
  @service
  permissions;

  @service
  session;

  @service
  store;

  @computed('session.{activeSchool,personId}')
  get filteredGroups() {
    if (!this.permissions.meet('urn:linced:organisation:role:staff')) {
      // Learners and Caregivers can't post to a group, so don't bother filtering - just return an empty array.
      return [];
    }

    let currentYear = moment().year();
    return this.store
      .peekAll('group')
      .filter((group) => {
        // A year of 0 (the Go zero value) means no year.
        if (group.year && group.year !== currentYear) {
          // Omit groups from other years.
          return false;
        }
        if (group.membershipHidden) {
          return false;
        }
        if (group.type === GroupType.GROUP) {
          // Omit My Groups which the current user isn't a current staff member in.
          let staff = group.get('currentStaff') ?? [];
          return !!findBy(staff, 'personId', this.session.personId);
        }
        // Include all other groups.
        return true;
      })
      .sort(
        (a, b) =>
          a.type - b.type || (a.label || '').localeCompare(b.label || ''),
      );
  }
}
